'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _pulse = require('../loaders/pulse');

var _pulse2 = _interopRequireDefault(_pulse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$trackerId = _ref.trackerId,
        trackerId = _ref$trackerId === undefined ? 'pulse-engagement-ui' : _ref$trackerId;

    return {
        track: function track(params) {
            return new _promise2.default(function (resolve, reject) {
                if (!params) {
                    return reject(new Error('Tracking params must be specified'));
                }

                return (0, _pulse2.default)({ providerId: params.site, trackerId: trackerId }).then(function (tracker) {
                    return tracker.evaluateEventInputs('trackerEvent').then(function (_ref2) {
                        var target = _ref2.object;
                        var _params$action = params.action,
                            action = _params$action === undefined ? 'Click' : _params$action,
                            _params$trackerType = params.trackerType,
                            trackerType = _params$trackerType === undefined ? 'Engagement' : _params$trackerType,
                            _params$objectType = params.objectType,
                            objectType = _params$objectType === undefined ? 'UIElement' : _params$objectType;


                        var uiEvent = {
                            object: {
                                type: objectType,
                                id: params.content.id,
                                name: params.content.name
                            },
                            type: trackerType,
                            action: action,
                            target: target,
                            actor: {
                                id: params.userId,
                                realm: params.userRealm
                            }
                        };

                        tracker.track('trackerEvent', uiEvent).then(function () {
                            return resolve({
                                response: 'Pulse engagement ui tracking completed.',
                                params: params,
                                trackerId: trackerId
                            });
                        });
                    });
                }).catch(reject);
            });
        }
    };
};
//# sourceMappingURL=ui.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/trackers/pulse/engagement/ui.js
 ** module id = 630
 ** module chunks = 1
 **/